import React from 'react';
import { Bottle } from './Bottle';
import { Chamber } from './Chamber';
import { FluidFlow } from './FluidFlow';
interface SchematicDiagramProps {
  bottles: {
    pbs: {
      level: number;
      filling: boolean;
    };
    pathogen: {
      level: number;
      filling: boolean;
    };
    waste: {
      level: number;
      filling: boolean;
    };
  };
  chambers: {
    id: number;
    filled: boolean;
    detecting: boolean;
    spceActive: boolean;
    liquidColor: string;
  }[];
  flows: {
    pbsToChamber: boolean;
    pathogenToChamber: boolean;
    chamberToWaste: boolean;
  };
}
export const SchematicDiagram: React.FC<SchematicDiagramProps> = ({
  bottles,
  chambers,
  flows
}) => {
  return <div className="bg-white dark:bg-gray-800 rounded-lg shadow-md p-3 flex-1 flex flex-col relative" data-id="element-130">
      <h2 className="text-base font-semibold mb-2 text-center" data-id="element-131">
        PathoPlex32 Instrument Schematic
      </h2>
      <div className="flex flex-1 flex-col md:flex-row relative" data-id="element-132">
        {/* Left Section - Bottles */}
        <div className="md:w-1/4 flex flex-col justify-around items-center mb-3 md:mb-0 z-10" data-id="element-133">
          <Bottle label="PBS Solution" color="#007BFF" level={bottles.pbs.level} filling={bottles.pbs.filling} icon="drop" data-id="element-134" />
          <Bottle label="Pathogen Solution" color="#FFA500" level={bottles.pathogen.level} filling={bottles.pathogen.filling} icon="virus" data-id="element-135" />
        </div>
        {/* Center Section - Chambers */}
        <div className="md:w-2/4 grid grid-cols-2 gap-2 mb-3 md:mb-0 z-10" data-id="element-136">
          {chambers.map(chamber => <Chamber key={chamber.id} id={chamber.id} filled={chamber.filled} detecting={chamber.detecting} spceActive={chamber.spceActive} liquidColor={chamber.liquidColor} data-id="element-137" />)}
        </div>
        {/* Right Section - Waste */}
        <div className="md:w-1/4 flex justify-center items-center z-10" data-id="element-138">
          <Bottle label="Waste" color="#6C757D" level={bottles.waste.level} filling={bottles.waste.filling} icon="trash" data-id="element-139" />
        </div>
        {/* Fluid Flow Animations - positioned absolutely to overlay */}
        <div className="absolute inset-0 pointer-events-none" data-id="element-140">
          {flows.pbsToChamber && <>
              <FluidFlow from="pbs" to="chamber" chamberId={1} color="#007BFF" data-id="element-141" />
              <FluidFlow from="pbs" to="chamber" chamberId={2} color="#007BFF" data-id="element-142" />
              <FluidFlow from="pbs" to="chamber" chamberId={3} color="#007BFF" data-id="element-143" />
              <FluidFlow from="pbs" to="chamber" chamberId={4} color="#007BFF" data-id="element-144" />
            </>}
          {flows.pathogenToChamber && <>
              <FluidFlow from="pathogen" to="chamber" chamberId={1} color="#FFA500" data-id="element-145" />
              <FluidFlow from="pathogen" to="chamber" chamberId={2} color="#FFA500" data-id="element-146" />
              <FluidFlow from="pathogen" to="chamber" chamberId={3} color="#FFA500" data-id="element-147" />
              <FluidFlow from="pathogen" to="chamber" chamberId={4} color="#FFA500" data-id="element-148" />
            </>}
          {flows.chamberToWaste && <>
              <FluidFlow from="chamber" to="waste" chamberId={1} color="#6C757D" data-id="element-149" />
              <FluidFlow from="chamber" to="waste" chamberId={2} color="#6C757D" data-id="element-150" />
              <FluidFlow from="chamber" to="waste" chamberId={3} color="#6C757D" data-id="element-151" />
              <FluidFlow from="chamber" to="waste" chamberId={4} color="#6C757D" data-id="element-152" />
            </>}
        </div>
      </div>
    </div>;
};